module.exports = __webpack_public_path__ + "media/images/emoticons/clock-db62f2db8b3195be38b5e585571b4815.gif";